import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Dropdown, MenuItem, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';

const { Selectors } = Data;

export class CarrierInfoModal extends Component {
    constructor() {
        super();
        this.state = {
            carrierData: {
                BOLNum: "",
                LTLCarrier: "",
                PRONum: "",
            },
            otherText: "",
        }
    }

    componentDidMount() {
        this.props.fetchCarrierInfo(this.props.salesOrderId).then((response) => {
            if (response.data) {
                this.initializeData(response.data);
                // this.setState({ carrierData: response.data });
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeData(data) {
        let front = "";
        let back = "";
        if (data && data.LTLCarrier && data.LTLCarrier.split(': ').length > 1) {
            front = data.LTLCarrier.split(': ')[0];
            back = data.LTLCarrier.split(': ')[1];
            data.LTLCarrier = front;
        }
        this.setState({ carrierData: data, otherText: back });
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        let { carrierData, otherText } = this.state;

        if (carrierData && carrierData.LTLCarrier === 'Other' && otherText) {
            carrierData.LTLCarrier = carrierData.LTLCarrier + ": " + otherText;
        }

        this.props.postCarrierInfo(this.props.salesOrderId, this.state.carrierData)
            .then((response) => {
                alert("Carrier Info Saved");
                this.props.closeCarrierInfoModal();
            }, (err) => {
                alert("Submit error:" + err.data);
            });
    }


    onChangeBol = (e) => {
        let { carrierData } = this.state;
        carrierData.BOLNum = e.target.value;
        this.setState({ carrierData });
    }
    onChangePro = (e) => {
        let { carrierData } = this.state;
        carrierData.PRONum = e.target.value;
        this.setState({ carrierData });
    }
    onChangeLTL = (e) => {
        let { carrierData } = this.state;
        carrierData.LTLCarrier = e.value;
        this.setState({ carrierData });
    }
    onChangeOtherText = (e) => {
        let { otherText } = this.state;
        otherText = e.target.value;
        this.setState({ otherText });
    }

    render() {
        const {
        } = this.props;

        const {
            carrierData,
            otherText,
        } = this.state;

        const LTLOptions = [
            {
                label: 'R & L Carriers Inc',
                value: 'R & L Carriers Inc',
            },
            {
                label: 'Roadrunner Transportation Services',
                value: 'Roadrunner Transportation Services',
            },
            {
                label: 'Estes Express Lines',
                value: 'Estes Express Lines',
            },
            {
                label: 'Daylight Transport',
                value: 'Daylight Transport',
            },
            {
                label: 'YRC',
                value: 'YRC',
            },
            {
                label: 'UPS Freight',
                value: 'UPS Freight',
            },
            {
                label: 'SAIA',
                value: 'SAIA',
            },
            {
                label: 'USF Reddaway',
                value: 'USF Reddaway',
            },
            {
                label: 'Mountain Valley Express',
                value: 'Mountain Valley Express',
            },
            {
                label: 'ProTrains International',
                value: 'ProTrains International',
            },
            {
                label: 'Other',
                value: 'Other',
            },
        ]

        return (
            <div>
                <Row>
                    <Col sm={6}>
                        <label><Translate value="bol_num" />:</label>
                    </Col>
                    <Col sm={6}>
                        <label><Translate value="pro_num" />:</label>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6}>
                        <Input
                            type="number"
                            value={carrierData.BOLNum}
                            onChange={this.onChangeBol}
                        // disabled={true}
                        />
                    </Col>
                    <Col sm={6}>
                        <Input
                            type="number"
                            value={carrierData.PRONum}
                            onChange={this.onChangePro}
                        // disabled={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm={10}>
                        <label><Translate value="ltl_carrier" />:</label>
                    </Col>
                </Row>
                <Row style={{ marginBottom: '12px' }}>
                    <Col sm={10}>
                        <Dropdown>
                            <Dropdown.Toggle style={{ width: '300px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                {carrierData.LTLCarrier}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                                {LTLOptions.map(el => {
                                    return (
                                        <MenuItem onClick={() => this.onChangeLTL(el)}>{el.label}</MenuItem>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>

                {
                    carrierData.LTLCarrier === 'Other' &&
                    <div>
                        <Row>
                            <Col sm={10}>
                                <label><Translate value="please_clarify_other" />:</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <Input
                                    type="text"
                                    value={otherText}
                                    onChange={this.onChangeOtherText}
                                // disabled={true}
                                />
                            </Col>
                        </Row>
                    </div>
                }
                <Row className="centerStyle" style={{ marginTop: '0px' }}>
                    <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSubmit(e); }}
                    // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="submit" />
                    </Button>
                </Row>

            </div>
        );
    }
}

export default CarrierInfoModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/carrierInfoModal.jsx